/**
 * Created by r4zi4l on 04.05.2022
 */

const OfferIcon = function (offer) {
    SideBarIcon.call(this, {
        animation: offer.sideBarJson,
        extraBarIcon: offer.extraBarIcon,
        priority: SideBar.PRIORITY_REDUNDANT
    });

    this.offer = offer;

    this.resetState();
};

OfferIcon.prototype = Object.create(SideBarIcon.prototype);
OfferIcon.prototype.constructor = OfferIcon;

OfferIcon.prototype.resetState = function () {
    const logic = this.offer.logic;

    this.available = logic.isIconAvailable();

    if (this.available) {
        this.setLeftTime(logic.getTimeLeft());
        this.setAttention(logic.hasIconAttention());

        if (this.getLeftTime() > 0) {
            this.setTitle(undefined);
        } else {
            this.setTitle(logic.hasIconAttention() ? Messages.get("Ready") : logic.getIconTitle && logic.getIconTitle());
        }
    }
};

OfferIcon.prototype.onPressed = function () {
    cleverapps.offerManager.showOfferWindow(this.offer);
};

OfferIcon.prototype.getForce = function () {
    return this.offer.force;
};